import { Check } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useErrorProps } from "../../helper/hooks/useErrorProps.js";
import { Tag } from "../tag/Tag.js";
import { TagGroup } from "../tagGroup/TagGroup.js";
import styles from "./TagInput.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TagInput({
  label,
  tags = [],
  errors = [],
  placeholder = 'Neues Element',
  variant = 'default',
  separators = [',', ';', 'Tab', 'Enter'],
  valid = false,
  allowDuplicates = false,
  onTagAdd,
  onTagDelete,
  children,
  className
}) {
  const [text, setText] = useState('');
  const [duplicated, setDuplicated] = useState([]);
  const {
    errorMessage,
    errorInputProps,
    hasError
  } = useErrorProps({
    error: errors.find(val => Boolean(val))
  });
  const handleTagSubmit = useCallback(() => {
    onTagAdd?.(text.trim());
    setText('');
  }, [onTagAdd, text]);
  const handleKeyDown = useCallback(e => {
    if (text === '' && e.key === 'Backspace' && tags.length > 0) {
      onTagDelete?.(tags[tags.length - 1]);
    }
    if (text.trim() === '') {
      return;
    }
    if (separators.includes(e.key)) {
      if (!allowDuplicates && tags.includes(text.trim())) {
        setDuplicated(prev => [...prev, text.trim()]);
        setText('');
        setTimeout(() => {
          setDuplicated(prev => prev.filter(t => t !== text.trim()));
        }, 250);
        e.preventDefault();
        return;
      }
      handleTagSubmit();
      e.preventDefault();
    }
  }, [allowDuplicates, handleTagSubmit, onTagDelete, separators, tags, text]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.tagInput, className),
    children: [/*#__PURE__*/_jsxs(TagGroup, {
      className: classnames(styles.tagEditor, {
        [styles.error]: hasError
      }),
      children: [/*#__PURE__*/_jsx("label", {
        className: classnames(styles.label),
        children: /*#__PURE__*/_jsx("span", {
          children: label
        })
      }), tags.map((t, index) => /*#__PURE__*/_jsx(Tag, {
        className: classnames(styles.tag, {
          [styles.duplicated]: duplicated.includes(t)
        }),
        onClick: () => onTagDelete?.(t),
        margin: false,
        size: variant,
        removable: true,
        hasError: Boolean(errors?.[index]),
        children: t
      }, t)), valid && /*#__PURE__*/_jsx(Check, {
        className: styles.checkmarkIcon
      }), children, /*#__PURE__*/_jsx("input", {
        value: text,
        onChange: e => setText(e.target.value),
        placeholder: placeholder,
        onKeyDown: handleKeyDown,
        className: classnames(styles.input, styles[variant]),
        ...errorInputProps
      })]
    }), errorMessage]
  });
}